export default __webpack_public_path__ + "static/media/290.988530f3.png";